import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { ENDPOINTS } from '../../helpers/constants';
import { postToday } from './helpers';

function CompleteModal({ lead, onClose, onSaved }) {
  const [followUpDate, setFollowUpDate] = useState('');
  const [saving, setSaving] = useState(false);

  const save = async skipDate => {
    setSaving(true);
    const saved = await postToday(ENDPOINTS.CONTACTS_TODAY_COMPLETE(lead._id), {
      followUpDate: skipDate ? '' : followUpDate,
      taskId: lead.taskId || undefined
    });
    setSaving(false);
    if (!saved) return;
    onSaved(
      skipDate
        ? `${lead.buyer} has no follow-up scheduled.`
        : `Next follow-up saved for ${lead.buyer}.`
    );
  };

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Complete follow-up</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>{lead.buyer}</strong>
        </p>
        <p className="small text-muted">{lead.reason}</p>
        {lead.taskId && (
          <p className="small">The task that put this card on Today will be marked complete.</p>
        )}
        <Form.Group className="mb-0">
          <Form.Label>Next follow-up date</Form.Label>
          <Form.Control type="date" value={followUpDate} onChange={event => setFollowUpDate(event.target.value)} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-dark" disabled={saving} onClick={() => save(true)}>
          Skip date
        </Button>
        <Button variant="success" disabled={!followUpDate || saving} onClick={() => save(false)}>
          Save next date
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CompleteModal;
